export default __webpack_public_path__ + "static/media/nhsa-national.eac3f0dc.png";